import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Fades sections in as they scroll into view; skipped for admin and reduced motion.
export const useReveal = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    if (pathname.startsWith("/admin") || window.matchMedia("(prefers-reduced-motion: reduce)").matches || !("IntersectionObserver" in window)) return;
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => { if (e.isIntersecting) { e.target.classList.add("reveal-in"); io.unobserve(e.target); } });
    }, { rootMargin: "0px 0px -8% 0px", threshold: 0.05 });
    const t = setTimeout(() => {
      document.querySelectorAll("main section > div").forEach((el) => {
        const r = el.getBoundingClientRect();
        if (r.top < window.innerHeight) return;
        el.classList.add("reveal");
        io.observe(el);
      });
    }, 150);
    return () => { clearTimeout(t); io.disconnect(); };
  }, [pathname]);
};
